// extracted by mini-css-extract-plugin
export default {"social-links":"UserHeader_social-links__0T7XN","user_name-title":"UserHeader_user_name-title__7KXUF"};